import { render, staticRenderFns } from "./uk.vue?vue&type=template&id=16f83090&scoped=true&lang=html&"
import script from "./uk.vue?vue&type=script&lang=js&"
export * from "./uk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f83090",
  null
  
)

export default component.exports